import { useContext } from 'react'

import IssueReporterContext from '../../providers/IssueReporterProvider.jsx'

const useIssueReporter = () => {
    return useContext(IssueReporterContext)
}

export default useIssueReporter
